import { useContext } from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';
import { arrayOf, bool, func, object, string } from 'prop-types';

import { BundleCampaignContext } from '~/components/LootPackViews/BundleSelector/BundleCampaignProvider';

import BundleButton from './BundleButton';

import style from './BundleSelector.module.scss';

const BundleSelector = ({
  bundleSelected,
  bundles,
  bonuses,
  onSelectBundle,
  className,
  noBackground,
  showAmountHeader,
}) => {
  const { tooltip } = useContext(BundleCampaignContext);

  if (!bundles?.length) {
    return null;
  }

  return (
    <>
      {!showAmountHeader && tooltip}
      <div className={className}>
        {showAmountHeader && <h3>{I18n.t('amount')}</h3>}
        {showAmountHeader && tooltip}
        <div
          className={classNames(style.bundleSelector, {
            withBonus:
              !showAmountHeader &&
              (bundles.some((bundle) => bonuses[bundle] > 0) || tooltip),
            noBackground,
          })}
        >
          {bundles.map((bundle) => (
            <BundleButton
              key={bundle}
              bundle={bundle}
              selected={bundle === bundleSelected}
              bonus={bonuses[bundle]}
              onClick={() => onSelectBundle(bundle)}
              available
            />
          ))}
        </div>
      </div>
    </>
  );
};

BundleSelector.propTypes = {
  bundleSelected: string,
  bundles: arrayOf(string),
  bonuses: object,
  onSelectBundle: func,
  noBackground: bool,
  className: string,
  showAmountHeader: bool,
};

export default BundleSelector;
